export const BROADCAST_CHANNEL = 'internal-sign-in-notifications';
export const INTERVAL_SESSION_MODAL = 10 * 1000;
